import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "note" }

import { computed } from 'vue';
  
  import { useStore } from 'vuex';

  // Access Vuex store
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ExposureListItem',
  props: {
    id: {},
    date: {},
    anxiety_level: {},
    taste: {},
    bodys_reaction: {},
    additional_notes: {},
    dish_id: {}
  },
  setup(__props: any) {

  const store = useStore();
    
  const props = __props;


  const formattedDate = computed(() => {
    const dateObj = new Date(props.date);
    return dateObj.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
  });

  
return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: '/dish/' + _ctx.dish_id + '/log/' + _ctx.id,
    class: "item"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fal', 'memo-pad'],
          class: "fa-lg"
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(formattedDate.value), 1),
        _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.bodys_reaction ?? "No notes logged"), 1)
      ]),
      _createVNode(_component_font_awesome_icon, {
        class: "chevron-icon fa-sm",
        icon: ['fas', 'chevron-right']
      })
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})